export type Locale = 'en' | 'ar';

export const LOCALES: readonly Locale[] = ['en', 'ar'] as const;

export function isLocale(value: string): value is Locale {
  return LOCALES.some((l) => l === value);
}

export const DEFAULT_LOCALE: Locale = 'en';
